<template>
  <RfStatusEnabled v-if="isEnabled" />
  <RfStatusDisabled v-else />
</template>

<script setup>
import RfStatusDisabled from "@/components/statuses/RfStatusDisabled.vue";
import RfStatusEnabled from "@/components/statuses/RfStatusEnabled.vue";

defineProps({ isEnabled: { type: Boolean, default: false } });
</script>
